import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { CollapsibleSection } from "@/components/CollapsibleSection";
import { DetailAdditionalSection, Section } from "@/components/details";
import { contestAgreementDetail } from "@/schemas/contestAgreement";
import { useContestAgreementData } from "../hooks/useContestAgreementData";
import { useContestAgreementId } from "../hooks/useContestAgreementId";
import { Module, PATH_CONTRACTOR } from "@/constants";
import { EntityListLink } from "@/components/EntityListLink";
import { useContestAgreementsFieldPermissions } from "../hooks/useContestAgreementsFieldPermissions";

export const ContestAgreementDetails = () => {
  const { t } = useTranslation();
  const id = useContestAgreementId();
  const contestAgreement = useContestAgreementData(id);
  const { canSeePresentationImageCount } =
    useContestAgreementsFieldPermissions();

  return (
    <>
      <CollapsibleSection title={t("contestAgreements.detail.basicDataHeader")}>
        <Section
          module={Module.ContestAgreements}
          schema={contestAgreementDetail}
          data={contestAgreement}
        >
          <Section.Column>
            <Section.Field field="contractor_user_ref_number" />
            <Section.Field field="contractor_full_name" />
            <Section.Field field="period" />
            <Section.Field
              field="agreement2_presentation_image_count"
              isVisible={canSeePresentationImageCount}
            />
          </Section.Column>
          <Section.Column>
            <Section.Field field="agreement_company_name" />
            <Section.Field field="agreement_start_date" />
            <Section.Field field="agreement2_sent_at" />
            <Section.Field field="agreement2_sign_date" />
            <Section.Field field="payroll_version" />
          </Section.Column>
        </Section>

        <Separator className="my-4" />

        <DetailAdditionalSection
          title={t("contractors.details.title")}
          headerAction={
            <EntityListLink
              path={generatePath(PATH_CONTRACTOR, {
                contractorId: contestAgreement.contractor_id,
              })}
              className="h-7 w-7 shrink-0"
            />
          }
        >
          <Section
            module={Module.Contractors}
            schema={contestAgreementDetail}
            data={contestAgreement}
          >
            <Section.Column>
              <Section.Field field="contractor_email" />
            </Section.Column>
            <Section.Column>
              <Section.Field field="contractor_phone_number" />
            </Section.Column>
          </Section>
        </DetailAdditionalSection>
      </CollapsibleSection>
    </>
  );
};
